import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglefitComponent } from './simple-icons-googlefit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglefitComponent ],
    exports:      [ SimpleIconsGooglefitComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglefitModule {}
